/** Service Desk console (Filipino): calibrated categorization (M29-K-05; CRM-001, CRM-003). Same keys as the English file. */
export const serviceCategorization = {
  tabs: { accuracy: "Katumpakan ng kategorya" },
  banner: {
    on: {
      title: "Kusang inilalapat ang mga kategorya",
      body: "Inilalapat lang ang kategorya kapag magkapareho ang basa ng assistant at ng model ng workspace at ang score ay hindi bababa sa {{threshold}}. Ang iba ay naghihintay ng tao sa Kailangan ng kategorya.",
    },
    off_insufficient_data: {
      title: "Hindi pa kusang inilalapat ang mga kategorya",
      body: "Kailangan ng Sagot ng hindi bababa sa {{min}} tiket na pinili ng inyong team ang kategorya; {{count}} pa lang ang meron ang workspace na ito. Hanggang doon, naghihintay ng tao ang bawat bagong tiket sa Kailangan ng kategorya.",
    },
    off_by_setting: {
      title: "Nakapatay ang kusang paglalapat ng kategorya",
      body: "Naghihintay ng tao ang bawat bagong tiket sa Kailangan ng kategorya. I-on ito sa ulat ng katumpakan.",
    },
    noModel: "Wala pang na-train na model. Magti-train ito sa magdamag, o pindutin ang I-retrain ngayon sa ulat ng katumpakan.",
    open: "Buksan ang ulat ng katumpakan",
  },
  needs: {
    title: "Kailangan ng kategorya",
    subtitle: "Mga bukas na tiket na wala pang nag-aayos ng kategorya, kasama ang mungkahi at score nito.",
    link: "Kailangan ng kategorya",
    back: "Lahat ng tiket",
    list: "Mga tiket na kailangan ng kategorya",
    suggested: "Mungkahi: {{category}} ({{score}})",
    suggestedNoScore: "Mungkahi: {{category}} (wala pang score)",
    choose: "Kategorya ng {{number}}",
    confirm: "Kumpirmahin",
    set: "Itakda ang kategorya",
    done: "Ang {{number}} ay {{category}} na.",
    more: "Ipinapakita ang {{shown}} sa {{total}} tiket.",
    error: "Hindi ma-load ang mga tiket",
    errorHint: "Tingnan ang koneksyon at subukan muli.",
    retry: "Subukan muli",
    empty: {
      title: "Walang kailangang kategorya",
      hint: "May kategorya ang bawat bukas na tiket: kusang inilapat o inayos ng inyong team.",
      cta: "Bumalik sa mga tiket",
    },
  },
  chip: {
    applied: "inilapat",
    review: "kailangang suriin",
    agent: "itinakda ng agent",
    customer: "itinakda ng customer",
    meter: "Score ng {{name}}",
    thresholdMark: "Threshold {{threshold}}",
    threshold: "Threshold {{threshold}}, mula sa {{count}} nakaraang tiket.",
    change: "Baguhin",
  },
  accuracy: {
    window: "Ang huling anim na buwan, bawat buwan sa kalendaryo. Ang precision ay ang bahagi ng kusang inilapat na kategorya na hindi na kailangang itama.",
    needs: "Kailangan ng kategorya",
    csv: "I-download ang CSV",
    error: "Hindi ma-load ang ulat ng katumpakan",
    errorHint: "Tingnan ang koneksyon at subukan muli.",
    empty: {
      title: "Wala pang tiket na may kategorya",
      hint: "Kapag may mga bagong tiket nang nakategorya, lalabas dito ang precision, coverage at mga pagtatama kada buwan.",
    },
    tiles: {
      labelled: "Mga tiket na may label",
      labelledHint: "Kailangan ng {{min}} para sa auto-apply",
      threshold: "Naka-calibrate na threshold",
      thresholdHint: "Pinili para sa {{target}} na precision",
      precision: "Precision",
      coverage: "Coverage",
      corrections: "Mga pagtatama",
      noMonth: "Wala pang buwan",
    },
    model: {
      title: "Model",
      retrain: "I-retrain ngayon",
      queued: "Nagsimula na ang retraining. Karaniwang isang minuto.",
      none: "Wala pang na-train na model.",
      training: "Tine-train ang bersyon {{version}}...",
      failed: "Hindi naisagawa ang huling training: kulang ang {{count}} tiket na may label. Ginagamit pa rin ang dating model.",
      active: "Bersyon {{version}}, natuto sa {{count}} tiket noong {{when}}; {{precision}} ang precision sa mga tiket na hindi ginamit sa training.",
      monthly: "Kusang nagre-retrain ang model kada buwan.",
    },
    settings: {
      title: "Mga setting",
      auto: "Kusang ilapat ang mga kategorya",
      autoHint: "Nakapatay pa rin kapag wala pang {{min}} tiket na may label, anuman ang setting na ito.",
      target: "Target na precision",
      targetHint: "Pinipili ang threshold para tama ang bahaging ito ng kusang inilalapat sa mga tiket na hindi ginamit sa training.",
      save: "I-save ang mga setting",
      saved: "Na-save ang mga setting.",
      readOnly: "Ang mga miyembrong may pahintulot na mag-configure ng tiket lang ang makakapagbago nito.",
    },
    months: { title: "Kada buwan", month: "Buwan", precision: "Precision", coverage: "Coverage", corrections: "Mga pagtatama" },
    byCategory: { title: "Kada kategorya", month: "Buwan", category: "Kategorya" },
  },
} as const;
